import { useRef } from 'react';
import { useCanvasOffscreen } from '../CanvasOffscreen/canvas-offscreen';

export function Canvas() {
  const ref = useRef<HTMLCanvasElement>(null);
  useCanvasOffscreen(ref);
  return <canvas className="llm__canvas" ref={ref} />;
}
